// DS: i3.5
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ChevronLeft: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.2453 6.29289L9.29558 11.2426C8.90505 11.6332 8.90505 12.2663 9.29558 12.6569L14.2453 17.6066C14.6359 17.9971 15.269 17.9971 15.6595 17.6066C16.0501 17.2161 16.0501 16.5829 15.6595 16.1924L11.4174 11.949L15.6595 7.70711C16.0501 7.31658 16.0501 6.68342 15.6595 6.29289C15.269 5.90237 14.6359 5.90237 14.2453 6.29289Z" />
    </svg>
  </IconWrap>
);
ChevronLeft.displayName = 'ChevronLeft';

export default ChevronLeft;
